// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-97b9ff5e{50%{opacity:.5}}.skills-inventory-charts[data-v-97b9ff5e]{display:flex;flex-direction:row;grid-gap:24px;gap:24px}.skills-inventory-charts .chart-container[data-v-97b9ff5e]{border-radius:6px;background:#fff;width:min(100%,564px)}@media only screen and (max-width:1024px){.skills-inventory-charts[data-v-97b9ff5e]{grid-gap:16px;gap:16px;flex-direction:column}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
